import React, { useState } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { orderService } from '../services/api';
import './OrderQuery.css';

const OrderQuery = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState(null);

  const handleQuery = async (values) => {
    try {
      setLoading(true);
      const result = await orderService.queryOrderByNo(values.orderNo);
      if (result.success) {
        setOrderData(result.data);
      }
    } catch (error) {
      message.error(error.message || '查询订单失败');
      setOrderData(null);
    } finally {
      setLoading(false);
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      pending: { text: '待支付', color: '#faad14' },
      paid: { text: '已支付', color: '#52c41a' },
      completed: { text: '已完成', color: '#1890ff' },
      cancelled: { text: '已取消', color: '#d9d9d9' },
      refunded: { text: '已退款', color: '#ff4d4f' }
    };
    return statusMap[status] || { text: status, color: '#000' };
  };

  return (
    <div className="order-query-page">
      <Card title="订单查询" style={{ maxWidth: 600, margin: '0 auto' }}>
        <Form form={form} onFinish={handleQuery} layout="vertical">
          <Form.Item
            label="订单号"
            name="orderNo"
            rules={[{ required: true, message: '请输入订单号' }]}
          >
            <Input 
              placeholder="请输入订单号" 
              size="large"
              prefix={<SearchOutlined />}
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              size="large" 
              block 
              loading={loading}
            >
              查询订单
            </Button>
          </Form.Item>
        </Form>

        {orderData && (
          <div className="order-result">
            <div className="order-info-item">
              <span className="label">订单号:</span>
              <span className="value">{orderData.orderNo}</span>
            </div>
            <div className="order-info-item">
              <span className="label">商品名称:</span>
              <span className="value">{orderData.productName}</span>
            </div>
            <div className="order-info-item">
              <span className="label">购买数量:</span>
              <span className="value">{orderData.quantity}</span>
            </div>
            <div className="order-info-item">
              <span className="label">订单金额:</span>
              <span className="value price">¥{orderData.totalPrice}</span>
            </div>
            <div className="order-info-item">
              <span className="label">订单状态:</span>
              <span 
                className="value" 
                style={{ color: getStatusText(orderData.status).color }}
              >
                {getStatusText(orderData.status).text}
              </span>
            </div>
            <div className="order-info-item">
              <span className="label">创建时间:</span>
              <span className="value">
                {new Date(orderData.createdAt).toLocaleString('zh-CN')}
              </span>
            </div>
            {orderData.paidAt && (
              <div className="order-info-item">
                <span className="label">支付时间:</span>
                <span className="value">
                  {new Date(orderData.paidAt).toLocaleString('zh-CN')}
                </span>
              </div>
            )}

            {orderData.deliveryInfo && orderData.status === 'paid' && (
              <div className="delivery-content" style={{
                marginTop: '20px',
                padding: '16px',
                background: '#f6ffed',
                border: '2px solid #b7eb8f',
                borderRadius: '8px'
              }}>
                <h3 style={{ color: '#52c41a', marginBottom: '12px', fontSize: '16px' }}>🎁 卡密信息</h3>
                <pre style={{
                  background: '#fff',
                  padding: '12px',
                  borderRadius: '4px',
                  fontFamily: 'monospace',
                  fontSize: '14px',
                  margin: 0,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-all',
                  userSelect: 'all'
                }}>{orderData.deliveryInfo}</pre>
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
};

export default OrderQuery;
